// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__22Eq2","paramInput":"JobSimulator_paramInput__3JXk0","input":"JobSimulator_input__20N0H"};